import { render } from "./indexPromo.vue?vue&type=template&id=3c235e72"
import script from "./indexPromo.vue?vue&type=script&lang=js"
export * from "./indexPromo.vue?vue&type=script&lang=js"

import "./indexPromo.vue?vue&type=style&index=0&id=3c235e72&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__